export default [
	{
		image: 'symptom.png',
		key: 'symptom_question',
		title: 'Symptoms'
	},
	{
		image: 'cause_risk.png',
		key: 'cause_risk_question',
		title: 'Cause/Risks'
	},
	{
		image: 'diagnosis.png',
		key: 'diagnosis_treatment_question',
		title: 'Diagnosis'
	},
	{
		image: 'vital.png',
		key: 'vital_question',
		title: 'Vitals'
	},
	{
		image: 'activity.png',
		key: 'activity_question',
		title: 'Activities'
	},
	{
		image: 'medication.png',
		key: 'medication_question',
		title: 'Medication'
	},
	{
		image: 'coping_and_living.png',
		key: 'coping_living_question',
		title: 'Coping and Living'
	},
	{
		image: 'lifestyle.png',
		key: 'lifestyle_question',
		title: 'Lifestyle'
	},
	{
		image: 'cause_risk.png',
		key: 'other_question',
		title: 'Other'
	}
]
